import { useTranslation } from 'react-i18next'

import { getEntityProfileTabs } from '../../../Entity'
import { Skeleton } from '../../../Skeleton'
import { TabScrollList } from '../../../Tab'
import {
  useApplicantProfileContext,
  useApplicantProfileTabsActiveTab,
} from '../RentalPortalApplicantProfile.hooks'

import {
  APPLICANT_PROFILE_TAB_LIST,
  QA_NAME_APPLICANT_PROFILE_TABS,
} from './RentalPortalApplicantProfileTabs.constants'
import {
  getApplicantProfileTabContent,
  getApplicantProfileTabCounters,
} from './RentalPortalApplicantProfileTabs.utils'

import * as styles from './RentalPortalApplicantProfileTabs.module.css'

function RentalPortalApplicantProfileTabs() {
  const { t } = useTranslation()

  const { applicantData, applicantId, isInitiated } =
    useApplicantProfileContext()

  const preparedTabs = getEntityProfileTabs({
    counters: getApplicantProfileTabCounters(applicantData?.counts),
    entityData: applicantData,
    t,
    tabs: APPLICANT_PROFILE_TAB_LIST,
  })

  const { activeTabId, handleSetActiveTab } = useApplicantProfileTabsActiveTab({
    applicantData,
    preparedTabs,
  })

  return (
    <>
      {isInitiated ? (
        <TabScrollList
          activeTab={activeTabId}
          preparedTabs={preparedTabs}
          sectionQaName={QA_NAME_APPLICANT_PROFILE_TABS}
          wrapperClassName={styles.tabsWrapper}
          onSetActiveTab={handleSetActiveTab}
        />
      ) : (
        <Skeleton className={styles.skeleton} />
      )}
      {getApplicantProfileTabContent({ activeTabId, applicantId })}
    </>
  )
}

export default RentalPortalApplicantProfileTabs
